<template>
  <div class="file">
    <div
      style="
        height: 40px;
        display: flex;
        font-size: 18px;
        font-weight: bold;
        align-items: center;
      "
    >
      <div style="margin-right: 10px">
        <el-button type="primary" @click="$router.go(-1)"
          ><i class="el-icon-back" style="margin-right: 10px"></i>
          后退前页</el-button
        >
      </div>
      <div style="color: #000">
        <span
          style="cursor: pointer"
          @click="$router.push('/ProjectInfo/ProjectAll?id=' + $route.query.id)"
          >{{ backName || '工作台' }}</span
        >
        <i class="el-icon-arrow-right"></i>
      </div>
      <div style="color: #606266" class="ellipsis">项目文档</div>
    </div>
    <el-container class="main-container">
      <el-aside width="150px" class="aside">
        <div class="Menu">
          <div
            :class="menuKey == item.DicKey ? 'menuItem menuActive' : 'menuItem'"
            v-for="(item, index) in Menu"
            :key="item.DicKey"
            @click="menuChange(item, index)"
            style="width: 100%"
          >
            {{ item.DicName }}
          </div>
        </div>
      </el-aside>
      <el-container>
        <el-header class="header" height="auto">
          <div style="width: 100%">
            <el-form
              ref="form"
              :model="SearchForm[menuKey]"
              label-width="100px"
              size="mini"
              @submit.native.prevent
            >
              <el-row :gutter="10">
                <el-col :span="5" v-if="menuKey === 'Device'">
                  <el-form-item label="供应商类型">
                    <el-select
                      v-model="
                        SearchForm[menuKey].Search.SupplierClassificationId
                      "
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="item in SupplierClassificationList"
                        :key="item.Id"
                        :label="item.DicName"
                        :value="item.Id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="供应商名称">
                    <!-- <el-input
                      v-model="SearchForm[menuKey].Search.supplier"
                      placeholder="请输入供应商名称"
                      style="width: calc(100%)"
                    ></el-input> -->
                    <el-select
                      v-model="SearchForm[menuKey].Search.supplier"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="item in SupplierData"
                        :key="item.Id"
                        :label="item.title"
                        :value="item.title"
                      ></el-option>
                    </el-select> </el-form-item
                ></el-col>
                <el-col :span="5">
                  <el-form-item label="文件类型">
                    <!-- <el-input
                      v-model="SearchForm[menuKey].Search.DocType"
                      placeholder="请输入文件类型"
                    ></el-input> -->
                    <!-- //项目资料 -->
                    <el-select
                      v-if="menuKey == 'Project'"
                      v-model="SearchForm[menuKey].Search.DocType"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="item in SupplierQualificationsList"
                        :key="item.Id"
                        :label="item.DicName"
                        :value="item.DicName"
                      ></el-option>
                    </el-select>
                    <!-- //资质供应商 -->
                    <el-select
                      v-if="menuKey == 'Supplier'"
                      v-model="SearchForm[menuKey].Search.DocType"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="item in SupplierTypeList"
                        :key="item.Id"
                        :label="item.DicName"
                        :value="item.DicName"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-if="menuKey == 'Device'"
                      v-model="SearchForm[menuKey].Search.DocType"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="item in DeviceTypeList"
                        :key="item.Id"
                        :label="item.DicName"
                        :value="item.DicName"
                      ></el-option>
                    </el-select> </el-form-item
                ></el-col>
                <el-col :span="5">
                  <el-form-item label="文件名称">
                    <el-input
                      placeholder="请输入文件名称"
                      v-model="SearchForm[menuKey].Search.DocName"
                    ></el-input> </el-form-item
                ></el-col>
                <el-col :span="4">
                  <el-button type="primary" style="width: 60px" @click="search"
                    >查询</el-button
                  >
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div style="position: relative; width: 50%"></div>
        </el-header>

        <el-main v-loading="loading" style="display: flex">
          <div
            style="width: 200px; overflow-y: auto"
            v-if="menuKey == 'Device'"
          >
            <div
              style="
                position: sticky;
                top: 0px;
                left: 0px;
                z-index: 999;
                height: 40px;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                background-color: #fff;
              "
            >
              <el-input
                placeholder="输入关键字进行过滤"
                v-model="filterText"
                @input="leftDataSearch"
                style="width: 100%"
              >
              </el-input>
            </div>
            <div style="margin-top: 10px">
              <el-tree
                ref="tree"
                :data="TreeData"
                node-key="Id"
                :expand-on-click-node="false"
                :props="defaultProps"
                @node-click="handleNodeClick"
                :filter-node-method="filterNode"
                highlight-current
                :indent="5"
              >
              </el-tree>
            </div>
          </div>
          <div
            :style="`${
              menuKey == 'Device'
                ? 'width: calc(100% - 200px);'
                : 'width: 100%;'
            } overflow-y: auto`"
          >
            <div v-if="TableData[menuKey].length > 0" class="center">
              <el-table
                :data="TableData[menuKey]"
                style="width: 100%"
                size="mini"
                :header-row-style="{
                  padding: '10px !important;',
                }"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  width="55"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="device_no"
                  label="设备编号"
                  align="center"
                  v-if="menuKey == 'Device'"
                ></el-table-column>
                <el-table-column
                  prop="device_name"
                  label="设备名称"
                  align="center"
                  v-if="menuKey == 'Device'"
                ></el-table-column>
                <el-table-column
                  prop="InstallationAreaName"
                  label="安装位置"
                  align="center"
                  v-if="menuKey == 'Device'"
                ></el-table-column>
                <el-table-column
                  prop="SupplierName"
                  label="供应商名称"
                  max-width="350px"
                  align="left"
                ></el-table-column>
                <el-table-column
                  :prop="TypeName"
                  label="文件类型"
                  width="200px"
                  align="left"
                ></el-table-column>

                <el-table-column
                  :prop="OriginalFileName"
                  label="文件名称"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <a
                      :href="
                        menuKey == 'Device'
                          ? scope.row.ServerPath
                          : scope.row.Url
                      "
                      target="_blank"
                      style="color: #409eff"
                      >{{
                        menuKey == 'Project'
                          ? scope.row.NewFileName
                          : menuKey == 'Supplier'
                          ? scope.row.NewFileName
                          : scope.row.DocumentName
                      }}</a
                    >
                  </template>
                </el-table-column>
                <el-table-column :prop="Size" label="文件大小" width="100px">
                  <template slot-scope="scope">
                    {{ setSize(scope.row[Size]) }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="CreateTime"
                  label="上传日期"
                  width="150px"
                >
                  <template slot-scope="scope">
                    {{
                      moment(scope.row.CreateTime).format('YYYY-MM-DD HH:mm:ss')
                    }}
                  </template>
                </el-table-column>

                <!-- <el-table-column label="操作" width="140" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click.stop="download(scope.row)"
                      icon="el-icon-download"
                      style="margin-left: 10px; font-size: 14px"
                      >下载</el-button
                    >
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
            <el-empty description="暂无数据" v-else></el-empty>
          </div>
        </el-main>
        <el-footer
          height="40px"
          style="display: flex; align-items: center; justify-content: right"
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="SearchForm[menuKey].PageIndex"
            :page-sizes="[40, 80, 160, 320, 500, 1000]"
            :page-size="SearchForm[menuKey].PageRows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="SearchForm[menuKey].total"
          >
          </el-pagination>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>
<script>
// import video from '@/assets/video.png'

import tools from '@/utils/tools'
import moment from 'moment'

export default {
  data() {
    return {
      backName: '',
      // video,

      moment,
      tools,
      checked: false,
      drawer: false,
      cardChecked: [],
      TableList: [],
      filterText: '',
      qrcode: '',
      qrcodeVisible: false,

      Menu: [
        {
          DicKey: 'Project',
          DicName: '项目文档',
        },
        {
          DicKey: 'Device',
          DicName: '设备文档',
        },
        {
          DicKey: 'Supplier',
          DicName: '供应商文档',
        },
      ],
      TreeData: [],
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      menuKey: 'Project',
      appListData: [],
      taskListData: [],
      pagination: {
        PageRows: 40,
        PageIndex: 1,
        total: 0,
      },
      loading: false,

      SearchFormLoading: false,
      shareInfoFlag: false,
      shareInfoData: [],
      sharePagination: {
        PageRows: 40,
        PageIndex: 1,
        total: 0,
      },
      shareInfo: {},
      TableData: {
        Project: [],
        Supplier: [],
        Device: [],
      },
      SearchForm: {
        Project: {
          PageRows: 40,
          PageIndex: 1,
          total: 0,
          Search: {
            timeData: [],
            projectId: '',
            supplier: '',
            DocType: '',
            DocName: '',
            sDate: '',
            eDate: '',
          },
        },
        Supplier: {
          PageRows: 40,
          PageIndex: 1,
          total: 0,
          Search: {
            timeData: [],
            projectId: '',
            supplier: '',
            DocType: '',
            DocName: '',
            sDate: '',
            eDate: '',
          },
        },
        Device: {
          PageRows: 40,
          PageIndex: 1,
          total: 0,
          Search: {
            timeData: [],
            projectId: '',
            DeviceType: '',
            supplier: '',
            DocType: '',
            DocName: '',
            sDate: '',
            eDate: '',
            SupplierClassificationId: '',
          },
        },
      },

      SupplierClassificationList: [],
      SupplierQualificationsList: [],
      SupplierTypeListAllChange: [],
      SupplierData: [],
      DeviceTypeList: [],
    }
  },
  props: {
    // pId: {
    //   type: String,
    //   default: "",
    // },
    parentOBJ: { type: Object },
  },
  components: {},
  methods: {
    getDeviceTypeList() {
      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'DeviceDocumentType',
        })
        .then((res) => {
          if (res.Success) {
            this.DeviceTypeList = res.Data || []
          }
        })
    },
    // 下拉
    getSelectList() {
      let arr = ['SupplierType', 'SupplierQualifications']

      arr.forEach((item) => {
        this.$http
          .post(`/PB/PB_Project/GetProjectPanelData`, {
            Panel: 'TheDataByDicKey',
            Keyword: item,
          })
          .then((res) => {
            if (res.Success)
              this[item + 'List'] = res.Data.DictionaryDetailsList || []
          })
      })
    },
    getSupplierData() {
      this.$http

        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'ProjectSupplierTree',
          ProjectId: this.pId,
        })
        .then((res) => {
          if (res.Success) {
            this.SupplierData = res.Data
          }
        })
    },
    getSupplierClassificationList() {
      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'TheDataByDicKey',
          Keyword: 'SupplierClassification',
        })
        .then((res) => {
          if (res.Success) {
            this.SupplierClassificationList =
              res.Data.DictionaryDetailsList || []
          }
        })
    },
    leftDataSearch() {
      this.$refs.tree.filter(this.filterText)
    },
    async handleNodeClick(data) {
      if (data.title == '全部') {
        this.SearchForm.Device.Search.DeviceType = ''
      } else {
        this.SearchForm.Device.Search.DeviceType = data.Id
      }

      this.search()
      // console.log(data);
      // if (data.children) {
      //   this.$notify.warning("请选择下级分类");
      //   this.DataShow = false;
      //   this.TreeId = "";
      //   this.TreeName = "";
      // } else {
      //   this.TreeId = data.Id;
      //   this.TreeName = data.title;
      //   this.getTemplateInfo(this.TreeId);
      //   await this.getDeviceTabList(this.TreeId);
      // }
    },
    filterNode(value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    getTreeData() {
      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'FileDeviceType',
          ProjectId: this.pId,
        })
        .then((resJson) => {
          this.leftLoading = false
          if (resJson.Success) {
            let Data = resJson.Data.Data
            Data.forEach((item) => {
              item.title = '全部'
            })
            this.TreeData = Data
          }
        })
    },
    setSize(size) {
      let data = ''
      const _size = Number.parseFloat(size)
      if (_size < 1 * 1024) {
        //如果小于0.1KB转化成B
        data = _size.toFixed(2) + 'B'
      } else if (_size < 1 * 1024 * 1024) {
        //如果小于0.1MB转化成KB
        data = (_size / 1024).toFixed(2) + 'KB'
      } else if (_size < 1 * 1024 * 1024 * 1024) {
        //如果小于0.1GB转化成MB
        data = (_size / (1024 * 1024)).toFixed(2) + 'MB'
      } else {
        //其他转化成GB
        data = (_size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
      }
      const size_str = data + ''
      const len = size_str.indexOf('.')
      const dec = size_str.substr(len + 1, 2)
      if (dec == '00') {
        //当小数点后为00时 去掉小数部分
        return size_str.substring(0, len) + size_str.substr(len + 3, 2)
      }
      return size_str
    },
    splitFilename(filename) {
      // 查找最后一个'.'的位置
      const lastIndex = filename.lastIndexOf('.')

      // 如果没有'.'，则整个字符串为文件名，后缀为空
      if (lastIndex === -1) {
        return [filename, '']
      }

      // 截取文件名和后缀
      const name = filename.slice(0, lastIndex)
      const extension = filename.slice(lastIndex + 1)

      return [name, extension]
    },
    createAdownload(href) {
      const loading = this.$loading({
        lock: true,
        text: '下载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      var a = document.createElement('a')
      a.href = href
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
      loading.close()
    },
    getWord(item) {
      if (item.WordUrl) {
        this.createAdownload(item.WordUrl)
        return
      }

      this.$http
        .post('/Base_ProjectWork/Base_Project/GetPdfToWord?Id=' + item.ReportId)
        .then((res) => {
          item.loading = false
          if (res.Success) {
            item.WordUrl = res.Data
            this.createAdownload(item.WordUrl)
          } else this.$notify.error(res.Msg)
        })
    },
    async getExcel(item) {
      var splitFilename = item.FileName.split('.')
      splitFilename.pop()
      var newFilename = splitFilename.join('.')
      await tools.download(
        this.$rootUrl +
          '/Base_ProjectWork/Base_Project/GetProjectReport?Id=' +
          item.ReportId,
        newFilename,
        '.xlsx'
      )
    },
    copyUrl(text) {
      var input = document.createElement('input') // 创建input对象
      input.value = text // 设置复制内容
      document.body.appendChild(input) // 添加临时实例
      input.select() // 选择实例内容
      document.execCommand('Copy') // 执行复制
      document.body.removeChild(input) // 删除临时实例
      this.$notify.success('复制成功！')
    },
    search() {
      this.SearchForm[this.menuKey].PageIndex = 1
      this.getDataList()
    },
    timeChange(time) {
      if (time) {
        this.SearchForm[this.menuKey].Search.sDate = time[0]
        this.SearchForm[this.menuKey].Search.eDate = time[1]
      } else {
        this.SearchForm[this.menuKey].Search.sDate = ''
        this.SearchForm[this.menuKey].Search.eDate = ''
        this.SearchForm[this.menuKey].Search.timeData = []
      }
      console.log(time)
      this.search()
      // this.pagination.PageIndex = 1;
      // this.getDataList();
    },

    getDataList() {
      this.loading = true
      let url = ''
      let Panel = ''
      if (this.menuKey == 'Project') {
        url = '/Base_ProjectWork/Base_Project/GetProjectSupplierDocument'
        Panel = 'FileProject'
      } else if (this.menuKey == 'Supplier') {
        Panel = 'FileSupplier'
        url = '/Base_ProjectWork/Base_Project/GetSupplierDocument'
      } else if (this.menuKey == 'Device') {
        Panel = 'FileDevice'
        url = '/Base_ProjectWork/Base_Project/GetDeviceDocument'
      }
      let searchData = {}
      this.SearchForm[this.menuKey].Search.projectId = this.pId
      searchData = {
        Panel,
        PageIndex: this.SearchForm[this.menuKey].PageIndex,
        PageRows: this.SearchForm[this.menuKey].PageRows,
        SortField: 'CreateTime',
        SortType: 'desc',
        ...this.SearchForm[this.menuKey].Search,
        // Search: { },
      }
      this.$http
        .post('/PB/PB_Project/GetProjectPanelData', searchData)
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.TableData[this.menuKey] = res.Data || []
            this.SearchForm[this.menuKey].total = res.Total || 0
          } else {
            this.$notify.error(res.Msg)
            this.TableData[this.menuKey] = res.Data || []
            this.SearchForm[this.menuKey].total = res.Total || 0
          }
        })
    },
    // 左侧菜单点击
    menuChange(item) {
      if (item.DicKey) {
        this.menuKey = item.DicKey
      } else {
        this.menuKey = ''
      }
      this.SearchForm[this.menuKey].Search.timeData = []
      this.SearchForm[this.menuKey].Search.supplier = ''
      this.SearchForm[this.menuKey].Search.DocType = ''
      this.SearchForm[this.menuKey].Search.DocName = ''
      this.SearchForm[this.menuKey].Search.sDate = ''
      this.SearchForm[this.menuKey].Search.eDate = ''
      this.SearchForm[this.menuKey].Search.SupplierClassificationId = ''
      this.SearchForm[this.menuKey].PageIndex = 1
      this.getDataList()
    },

    // 下载
    download(item) {
      let NewFileName =
        item[
          this.menuKey == 'Project'
            ? 'NewFileName'
            : this.menuKey == 'Supplier'
            ? 'NewFileName'
            : 'DocumentName'
        ]
      console.log(NewFileName, 'NewFileName')
      let Url =
        this.menuKey == 'Project'
          ? item.Url
          : this.menuKey == 'Supplier'
          ? item.Url
          : item.ServerPath
      const loading = this.$loading({
        lock: true,
        text: '下载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const elink = document.createElement('a')
      elink.download = NewFileName
      elink.style.display = 'none'
      elink.target = '_blank'
      elink.href = Url
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
      loading.close()
      // tools.download(item.FileWebURL, item.FileName)
      // window.open(item.FileWebURL)
      // console.log('下载')
    },
    handleSizeChange(val) {
      this.SearchForm[this.menuKey].PageIndex = 1
      this.SearchForm[this.menuKey].PageRows = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.SearchForm[this.menuKey].PageIndex = val
      this.getDataList()
    },
  },
  mounted() {},
  created() {
    this.pId = this.$route.query.id
    this.backName = window.localStorage.getItem('ProjectName') || ''
    // console.log(this.pId)
    // this.getAppListData()
    // this.getTypeData();
    // this.getTaskListData();
    this.getDataList()
    this.getTreeData()
    this.getSupplierClassificationList()
    this.getSupplierData()
    this.getSelectList()
    this.getDeviceTypeList()
  },
  computed: {
    OriginalFileName() {
      return this.menuKey == 'Project'
        ? 'NewFileName'
        : this.menuKey == 'Supplier'
        ? 'NewFileName'
        : 'DocumentName'
    },
    TypeName() {
      return this.menuKey == 'Project'
        ? 'TypeName'
        : this.menuKey == 'Supplier'
        ? 'TypeName'
        : 'DocumentTypeName'
    },
    Size() {
      return this.menuKey == 'Project'
        ? 'Size'
        : this.menuKey == 'Supplier'
        ? 'Size'
        : 'DocumentSize'
    },
  },
  watch: {},
}
</script>
<style lang="scss" scoped>
.file {
  padding: 10px;
  padding-top: 0;
}

.Menu {
  width: 100%;
  text-align: center;

  padding: 10px;
  position: relative;
  box-sizing: border-box;
  transition: all 70ms ease 0s;

  .menuItem {
    font-size: 14px;
    padding: 7px 10px;
    border-radius: 5px;
    box-sizing: border-box;
    margin-bottom: 5px;
    cursor: pointer;

    &:hover {
      background: #409eff;
      color: #fff;
      font-weight: 600;
    }
  }

  .menuActive {
    background: #409eff;
    color: #fff;
    font-weight: 600;
  }

  .shrink {
    position: absolute;
    bottom: 10px;
    right: -12px;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 23px;

    &:hover {
      color: #409eff;
      border-color: #409eff;
    }
  }
}

.main-container {
  background: #fff;
  overflow: hidden;
  height: calc(100vh - 130px);

  .aside {
    height: calc(100vh - 130px);
    background-color: #fff;
    border-right: 1px solid #ededed;
  }

  .header {
    height: auto;
    padding: 10px;
    border-bottom: 1px solid #ededed;
  }

  .center {
    display: flex;
    flex-wrap: wrap;
    // overflow-y: auto;
  }
}

.ellipsis {
  overflow: hidden; //超出隐藏

  text-overflow: ellipsis; //文本超出时显示省略号

  display: -webkit-box;

  -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）
  word-wrap: break-word;
  word-break: normal;
  -webkit-line-clamp: 2; //内容限制的行数
}

.ellipsis4 {
  overflow: hidden; //超出隐藏
  word-wrap: break-word;
  word-break: normal;
  text-overflow: ellipsis; //文本超出时显示省略号

  display: -webkit-box;

  -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）

  -webkit-line-clamp: 4; //内容限制的行数
}

.ellipsis1 {
  overflow: hidden; //超出隐藏
  word-wrap: break-word;
  word-break: normal;
  text-overflow: ellipsis; //文本超出时显示省略号

  display: -webkit-box;

  -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）

  -webkit-line-clamp: 1; //内容限制的行数
}

// ::v-deep.el-table thead tr th {
//   padding: 10px 0px !important;
//   background-color: #f5f7fa;
// }

::v-deep .el-table__row--striped {
  background-color: #f5f7fa !important;
}
::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #409eff;
  color: #fff;
  font-weight: bold;
}
</style>
